export * from "-!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--7-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--7-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/lib/index.js??ref--7-3!../../../node_modules/less-loader/dist/cjs.js??ref--7-4!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=style&index=0&id=4be089b7&prod&lang=less"


//////////////////
// WEBPACK FOOTER
// ./src/components/mask-page/index.vue?vue&type=style&index=0&id=4be089b7&prod&lang=less
// module id = squQ
// module chunks = 1